(function () {
  var STICKY_OFFSET = 40;

  function initHeader(root) {
    if (!root || root.dataset.customHeaderReady) return;
    root.dataset.customHeaderReady = 'true';

    var drawer = root.querySelector('.custom-header__drawer');
    var openButton = root.querySelector('[data-drawer-open]');
    var closeButton = drawer.querySelector('.custom-header__close');
    var closeTriggers = root.querySelectorAll('[data-drawer-close]');
    var cartLink = root.querySelector('.custom-header__cart');

    function openDrawer() {
      root.classList.add('is-open');
      drawer.removeAttribute('inert');
      openButton.setAttribute('aria-expanded', 'true');
      closeButton.focus({ preventScroll: true });
    }

    function closeDrawer() {
      var hadFocus = drawer.contains(document.activeElement);
      root.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      openButton.setAttribute('aria-expanded', 'false');
      if (hadFocus) openButton.focus({ preventScroll: true });
    }

    openButton.addEventListener('click', openDrawer);
    closeTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (!root.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeDrawer();
        openButton.focus();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusables = drawer.querySelectorAll('button, a[href]');
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      var inside = drawer.contains(document.activeElement);
      if (event.shiftKey && (!inside || document.activeElement === first)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (!inside || document.activeElement === last)) {
        event.preventDefault();
        first.focus();
      }
    });

    // Cart count badge: Dawn publishes cartUpdate after add, change and remove.
    function renderCartCount(count) {
      var badge = cartLink.querySelector('.custom-header__cart-count');
      if (count > 0) {
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'custom-header__cart-count';
          badge.setAttribute('aria-hidden', 'true');
          cartLink.appendChild(badge);
        }
        badge.textContent = count;
      } else if (badge) {
        badge.remove();
      }
      cartLink.setAttribute('aria-label', 'Cart, ' + count + ' items');
    }

    if (cartLink && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            return response.json();
          })
          .then(function (cart) {
            if (root.isConnected) renderCartCount(cart.item_count);
          })
          .catch(function () {});
      });
    }

    // Sticky header
    var frameRequested = false;

    function updateSticky() {
      frameRequested = false;
      if (!root.isConnected) return;
      var shouldStick = window.scrollY > STICKY_OFFSET;
      if (shouldStick && !root.classList.contains('is-sticky')) {
        document.body.style.paddingTop = root.offsetHeight + 'px';
        root.classList.add('is-sticky');
      } else if (!shouldStick && root.classList.contains('is-sticky')) {
        root.classList.remove('is-sticky');
        document.body.style.paddingTop = '';
      }
    }

    // Keeps focused elements and anchor targets from landing under the fixed header.
    function syncScrollPadding() {
      document.documentElement.style.scrollPaddingTop = root.offsetHeight + 'px';
    }

    window.addEventListener(
      'scroll',
      function () {
        if (frameRequested) return;
        frameRequested = true;
        window.requestAnimationFrame(updateSticky);
      },
      { passive: true }
    );

    var resizeFrame = null;
    window.addEventListener('resize', function () {
      if (resizeFrame) return;
      resizeFrame = window.requestAnimationFrame(function () {
        resizeFrame = null;
        if (root.isConnected) syncScrollPadding();
      });
    });

    syncScrollPadding();
    updateSticky();
  }

  function initAll() {
    document.querySelectorAll('[data-custom-header]').forEach(initHeader);
  }

  initAll();

  document.addEventListener('shopify:section:load', function (event) {
    var header = event.target.querySelector('[data-custom-header]');
    if (!header) return;
    document.body.style.paddingTop = '';
    initHeader(header);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.querySelector('[data-custom-header]')) {
      document.body.style.paddingTop = '';
      document.documentElement.style.scrollPaddingTop = '';
    }
  });
})();